import React from "react";
import JobsList from "go-component/components/Job/JobsList";

const UserLogsJobsIndexPage = () => {
	return <JobsList organization_name={""} />;
};
export default UserLogsJobsIndexPage;
